<aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="listaProcessado" indexColumnVisible="true" limit="10">
  
  <aslib-grid-column  [property]="'seqItem'" [visible]="false"  header="seqItem" class="text-right" [width]="10" 
    [sortable]="true" [resizable]="true">
  </aslib-grid-column>
  <aslib-grid-column [property]="'cpfCnpjCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="175"
    [sortable]="false" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.cpfCnpjCredor | cpf}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left"  [width]="450"  
  [sortable]="true" [resizable]="true">
  </aslib-grid-column>
  <aslib-grid-column [property]="'numeroProcessoSei'" header="Número do Processo SEI" class="text-left" [width]="220" 
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroProcessoSei | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'numeroEmp'" header="Número do EMP" class="text-right" [width]="175" 
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroEmp | pedEmpLiq}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'numeroLiq'" header="Número do LIQ" class="text-right" [width]="175"
      [sortable]="true" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroLiq | pedEmpLiq}}</span>
      </ng-template>
  </aslib-grid-column>
</aslib-grid>

<button type="button" class="btn btn-primary" (click)="gerarPDF()">Gerar PDF's</button>
<br>



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/processado/processado-liq.component.html